import React from 'react';
import { Skeleton } from '../Skeleton';

const GrCardV2Skeleton = () => {
  return (
    <>
      {/* <div className="w-100 grCardV2Box shadow rounded-3 text-start">

        <div className="grCardV2BoxPic cursorPointer rounded-3">
          <Skeleton width={'100%'} height={'100%'} variant="rectangular" />
        </div>

        <div className="crdV2topPart d-flex align-items-center justify-content-between"></div>
        <div className="d-flex text-start cardV2Topic">
          <h2 className="text-black fs-16 fw-medium line-clamp-2">
            <Skeleton width={100} height={25} variant="text" />
          </h2>
        </div>
        <div className="cardV2Ftr d-flex align-items-center justify-content-between">
          <Skeleton width={70} height={30} variant="rectangular" />
          <div className="cardV2FtrBtn fs-4 fw-medium rippleEffect rounded cursorPointer">
            <span>
              <Skeleton width={70} height={30} variant="rectangular" />
            </span>
          </div>
        </div>
      </div> */}
      <div className="w-100 grCardV2Box shadow rounded-3 text-start bg-white overflow-hidden position-relative p-3 p-lg-4">
        <div className="grCardV2BoxPic cursorPointer rounded-3 position-relative overflow-hidden z-1 mb-3 mb-lg-4">
          <Skeleton width={'100%'} height={'100%'} variant="rectangular" />
        </div>
        <div className="crdV2topPart d-flex align-items-center justify-content-between mb-3">
          <div className="text-black crdV2Speclty">
            <Skeleton width={100} height={25} variant="text" />
          </div>
        </div>
        <div className="d-flex text-start cardV2Topic">
          <h2 className={`text-black fs-16 fw-medium line-clamp-2 gtm_cl_grCardV2`}>
            <Skeleton width={80} height={30} variant="text" />
          </h2>
        </div>
        <ul className="cardV2Statistics mt-4 mb-0 ps-0 d-flex gap-2">
          <li className="me-3 mr-2 mb-4 d-flex align-items-center gap-1">
            <Skeleton width={50} height={20} variant="rectangular" className="rounded" />
          </li>
          <li className="me-3 mr-2 mb-4 d-flex align-items-center gap-1">
            <Skeleton width={50} height={20} variant="rectangular" className="rounded" />
          </li>
          <li className="me-3 mr-2 mb-4 d-flex align-items-center gap-1">
            <Skeleton width={50} height={20} variant="rectangular" className="rounded" />
          </li>
        </ul>
        <div className="cardV2Ftr d-flex align-items-center justify-content-between mt-3">
          <Skeleton width={100} height={25} variant="rectangular" className="rounded" />

          <div className="cardV2FtrBtn fs-4 fw-medium rippleEffect rounded d-inline-block overflow-hidden py-3 px-4 cursorPointer">
            <span className="position-relative z-1">
              <Skeleton width={100} height={25} variant="rectangular" className="rounded" />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default GrCardV2Skeleton;
